import Vue from 'vue'
import axios from 'axios'
axios.defaults.withCredentials=false;
import router from '../router'
Vue.prototype.$http = axios

var tokenParam = null;

// jq(document).ready(function () {

// 	getToken();

// 	test();
// });
let tokenHeaderName = 'Access-Control-Expose-Headers';
let TokenHandler = {
	getToken(params) {
		const queryString = params;
		const urlParams = new URLSearchParams(queryString);
		const token = urlParams.get('T');
		tokenParam = token;
		sessionStorage.setItem("token", token);
		return token;
	},

	postFun(uri, data, callback) {
		let token = sessionStorage.getItem("token");
		// console.log("token->" + token);

		axios.post(uri, data, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
				"Authorization": token
			}
		}).then((response) => {
			if (response.data.code == 1) {
				if (response.headers.token) {
					sessionStorage.setItem("token", response.headers.token);
				}
			}
			if (response.data.success == true) {
				if (response.headers.token) {
					sessionStorage.setItem("token", response.headers.token);
				}
			}
			callback(response.data);

		}).catch(error => {
			console.log(error.response);
		})
	},

	post(uri, data, callback) {
		let token = sessionStorage.getItem("token");
		// console.log("token->" + token);

		axios.post(uri, {
			params: data,
		}, {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
				"Authorization": token
			}
		}).then((response) => {
			if (response.data.code == 1) {
				if (response.headers.token) {
					sessionStorage.setItem("token", response.headers.token);
				}
			}
			if (response.data.success == true) {
				if (response.headers.token) {
					sessionStorage.setItem("token", response.headers.token);
				}
			}
			callback(response.data);

		}).catch(error => {
			console.log(error.response);
		})
	},
	get(uri, data, callback) {
		let token = sessionStorage.getItem("token");
		// console.log("token->" + token);

		axios.get(uri, {
			params: data,
			headers: {
				"X-Requested-With": "XMLHttpRequest",
				"Authorization": token
			}
		}).then(response => {
			if (response.data.success == true) {
				if (response.headers.token) {
					sessionStorage.setItem("token", response.headers.token);
				}
			}
			console.info("=========response.headers('Token'===============", response.headers.token);
			callback(response.data);

		}).catch(error => {
			console.log(error.response);
		})
	}
};
// axios.interceptors.response.use(

// 	//success => {
// 	// // VueCookie.set(tokenHeaderName, VueCookie.get(tokenHeaderName), {
// 	// // 	expires: '30m'
// 	// // });
// 	// console.info("====================",success.headers);
// 	// var disp = success.headers['Token'];
// 	// console.info("=========response.headers('Token'==============="+disp);
// 	// // if(disp){
// 	// // 	console.info("=========response.headers('Token'==============="+disp);
// 	// // 	this.$CONFIG.globalToken= disp;
// 	// // 	return success;

// 	// // }
// 	// // hidenLoading()
// 	// return success
// 	response => {
// 		// 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
// 		// 否则的话抛出错误
// 		// if (response.status === 200) {
// 		//   return Promise.resolve(response);
// 		// } else {
// 		//   return Promise.reject(response);
// 		// }
// 		console.log(response);
// 		if (response.data.success || response.data.success === undefined) {

// 			return response.data;
// 		} else {
// 			return response.data;
// 		}
// 	},
// 	error => {

// 		console.info("====================", error.response);
// 		if (error.response) {
// 			console.info(error.response);
// 			let path = router.currentRoute.fullPath;
// 			if (router.currentRoute.meta.noNeedLogin) {
// 				return Promise.reject({
// 					code: 0
// 				})
// 			} else {
// 				if (error.response.status == 401 || error.response.status == 409) {
// 					VueCookie.delete(tokenHeaderName);
// 					if (path.indexOf("redirect") == -1 && path.indexOf("login") == -1) {
// 						router.replace({
// 							path: '/login',
// 							query: {
// 								redirect: path
// 							} //登录成功后跳入浏览的当前页面
// 						})
// 					}
// 				}
// 			}
// 		}
// 		// hidenLoading();
// 		return Promise.reject(error)
// 	}
// );

export default TokenHandler



// WEBPACK FOOTER //
// ./src/shiro/TokenHandler.js